"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleCreateProject;
const either_1 = require("../../../types/either");
const CreateProject_1 = require("../../../actions/CreateProject");
const createBooksPrintableGroups_1 = require("../../../services/printables/createBooksPrintableGroups");
const hasBoxPrintableOption_1 = __importDefault(require("../hasBoxPrintableOption"));
const createPrintsPrintableGroups_1 = __importDefault(require("../../../services/printables/createPrintsPrintableGroups"));
const createFramesPrintableGroup_1 = __importDefault(require("../../../services/printables/createFramesPrintableGroup"));
const layers_1 = require("../../../helpers/HAMMER/layers");
const createCardsPrintableGroups_1 = __importDefault(require("../../../services/printables/cards/createCardsPrintableGroups"));
const numbers_1 = require("../../../helpers/numbers");
function handleCreateProject(action, dependencies) {
  return __awaiter(this, void 0, void 0, function* () {
    var _a;
    if (!(0, CreateProject_1.isCreateProject)(action)) {
      return (0, either_1.left)(new Error(`Action ${action.type} does not match CreateProject action schema`));
    }
    if (!dependencies.getTemplateAndProductOptions) {
      return (0, either_1.left)(new Error(`${action.type} requires dependency getTemplateAndProductOptions`));
    }
    const getTemplateAndProductOptionsResult = yield dependencies.getTemplateAndProductOptions(action.sku, action.options || {});
    if (getTemplateAndProductOptionsResult.isLeft()) {
      return (0, either_1.left)(getTemplateAndProductOptionsResult.value);
    }
    const {
      template,
      templateId,
      templateVersion,
      templateNameScheme,
      templateCategory,
      userCanAddText,
      templateAttributes,
      productOptions
    } = getTemplateAndProductOptionsResult.value;
    let createPrintableGroupsResult;
    // Check to see if this HAMMER file has options with design IDs,
    // if it does, ignore that old school design attribute boo boo
    const attributeWithDesignIds = Object.keys(templateAttributes).find(attribute => templateAttributes[attribute].options.some(value => !!value.designId));
    const defaultDesign = ((_a = template.designs.find(design => design.default === true)) === null || _a === void 0 ? void 0 : _a.id) || template.designs[0].id;
    if (attributeWithDesignIds) {
      productOptions[attributeWithDesignIds] = defaultDesign;
    } else if (templateCategory.includes('frames')) {
      // for frames default design is incorrect and needs to be overwritten with the template default design
      productOptions.design = defaultDesign;
    }
    const productName = buildProductNameFromSku(action.sku);
    const product = {
      sku: action.sku,
      name: productName,
      options: productOptions,
      hammerCategory: templateCategory,
      startingPageCount: Number(action.startingPageCount) || undefined
    };
    if (templateCategory.includes('books')) {
      // How many printables the books should be created with. (Note even though the options is called pages, it really means 'printable' - how many printables the
      // book should be created with)
      const pageCount = parseInt(product.options.pages || product.options.page_count || product.options.standard_page_count || '0', 10);
      // If the pages option was provided, use that for product.StartingPages
      if (pageCount > 0) {
        product.startingPageCount = templateCategory.includes('spread books') && product.options.pages ? pageCount * 2 : pageCount;
      }
      if (product.startingPageCount) {
        // Ensure the starting page count is in the range defined by the template
        const isInRange = (0, numbers_1.inRange)(templateCategory.includes('spread books') ? Math.ceil(product.startingPageCount / 2) : product.startingPageCount, template.pages.min, template.pages.max);
        if (!isInRange) {
          console.error(`Could not use startingPageCount = ${product.startingPageCount} because is not in the range, it will use default min pageCount`);
          product.startingPageCount = undefined;
        }
      }
      product.startingPageCount = product.startingPageCount || (templateCategory.includes('spread books') ? template.pages.min * 2 : template.pages.min);
      product.pageCount = product.startingPageCount;
    }
    if (templateCategory.includes('books')) {
      createPrintableGroupsResult = (0, createBooksPrintableGroups_1.createBooksPrintableGroups)({
        userId: action.userId,
        projectId: action.projectId,
        creationDate: action.timestamp,
        template,
        hammerCategory: templateCategory,
        currentPrintableGroups: undefined,
        minimumPageCountOverride: product.startingPageCount && templateCategory.includes('spread books') ? Math.ceil(product.startingPageCount / 2) : product.startingPageCount,
        hasBoxPrintableGroup: (0, hasBoxPrintableOption_1.default)(action.options || {}),
        mobileUserAgentCheck: !!action.mobile,
        userCanAddText,
        sku: product.sku
      });
    } else if (templateCategory.includes('prints')) {
      createPrintableGroupsResult = (0, createPrintsPrintableGroups_1.default)(action.userId, action.projectId, action.timestamp, template);
    } else if (templateCategory.includes('frames')) {
      createPrintableGroupsResult = (0, createFramesPrintableGroup_1.default)(action.userId, action.projectId, action.timestamp, template);
    } else if (templateCategory.includes('card')) {
      productOptions.envelope_addressing = 'none'; // Users must explicitly add addresses on step 2 in Editor (option selection remains on pdp for price transparency)
      const templateWithResolvedLayers = template.layers.find(layer => layer.dependsOn) ? Object.assign(Object.assign({}, template), {
        layers: (0, layers_1.resolveDependsOnValuesForLayers)(template.layers, templateAttributes, productOptions)
      }) : template;
      const cardPrintableGroups = (0, createCardsPrintableGroups_1.default)(action.userId, action.projectId, action.timestamp, templateWithResolvedLayers);
      createPrintableGroupsResult = (0, either_1.right)(cardPrintableGroups);
    } else {
      return (0, either_1.left)(new Error('Category not supported yet.'));
    }
    if (createPrintableGroupsResult.isLeft()) {
      return (0, either_1.left)(createPrintableGroupsResult.value);
    }
    const project = Object.assign({
      id: action.projectId,
      parentId: action.projectId,
      createdAt: action.timestamp,
      lastModifiedAt: action.timestamp,
      version: 1,
      versionStack: [1],
      versionHistory: [1],
      createdBy: action.userId,
      lastModifiedBy: action.userId,
      lastModifiedByAdmin: false,
      schemaVersion: 2,
      emptyPageAck: false,
      name: `Untitled ${productName} ${new Date(action.timestamp).toLocaleDateString()}`,
      status: 'IN_PROGRESS',
      templateId,
      templateVersion,
      templateNameScheme,
      product,
      printableGroups: createPrintableGroupsResult.value
    }, action.startingProjectQuantity ? {
      qty: action.startingProjectQuantity
    } : {});
    return (0, either_1.right)({
      updatedProject: project,
      updatedEntities: [project, ...project.printableGroups.map(pg => pg.printables).flat()]
    });
  });
}
function buildProductNameFromSku(sku) {
  const splitSku = sku.split('-').join(' ');
  return splitSku.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
}